import { render } from "./tagList.vue?vue&type=template&id=e266f3d4&scoped=true&lang=pug"
import script from "./tagList.vue?vue&type=script&setup=true&lang=js"
export * from "./tagList.vue?vue&type=script&setup=true&lang=js"

import "./tagList.vue?vue&type=style&index=0&id=e266f3d4&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e266f3d4"]])

export default __exports__